import React from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';
import styled from '@emotion/styled';
import { statusSeverity } from '../utils/statusColors';

const resolveTaskSeverity = (value) => {
    const deadline = statusSeverity('deadline', value);
    return deadline !== 'default' ? deadline : statusSeverity('priority', value);
};

const TaskContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[2],
    marginTop: theme.spacing(2),
    height: '100%',
}));

const BoxTitle = styled(Typography)(({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(3),
}));

const DataSet = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
}));

const DataSetItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
}));

const DatasetItemTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(0.5),
        fontSize: theme.typography.size.md,
    },
}));

const DataSetItemValue = styled(Typography)(({ theme, type }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: type === 'error' ? theme.palette.error.main : type === 'warning' ? theme.palette.warning.main : theme.palette.success.main,
    textAlign: 'left',
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
        marginBottom: theme.spacing(0.5),
        fontSize: theme.typography.size.md,
    },
}));

const DataDivider = styled(Divider)(({ theme }) => ({
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
}));

const ProfileTaskBox = ({ title = "", data1 = [], data2 = [], isLoading = false }) => {

    return (
        <Grid item xs={12} md={4} lg={4}>
            <TaskContainer>
                <BoxTitle variant="h5">{title}</BoxTitle>
                <DataSet>
                    {Object.entries(data1 || {}).map(([status, count], index) => (
                        <DataSetItem key={index}>
                            <DatasetItemTitle variant="body1">{status}</DatasetItemTitle>
                            <DataSetItemValue variant="overline" type={resolveTaskSeverity(status)}>{count}</DataSetItemValue>
                        </DataSetItem>
                    ))}
                </DataSet>
                {data2.length > 0 && (
                    <>
                        <DataDivider />
                        <DataSet>
                            {Object.entries(data2 || {}).map(([status, count], index) => (
                                <DataSetItem key={index}>
                                    <DatasetItemTitle variant="body1">{status}</DatasetItemTitle>
                                    <DataSetItemValue variant="overline" type={resolveTaskSeverity(status)}>{count}</DataSetItemValue>
                                </DataSetItem>
                            ))}
                        </DataSet>
                    </>
                )}
            </TaskContainer>
        </Grid>
    );
};

export default ProfileTaskBox;